import React from "react";
import { Box } from "@mui/material";
import { InsertDriveFile } from "@mui/icons-material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";

interface FileTypeIconProps {
  fileName: string;
  /** 表示サイズ (px) */
  size?: number;
}

const IMAGE_EXTS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg", "heic"];
const VIDEO_EXTS = ["mp4", "mov", "avi", "wmv", "mkv", "webm"];
const TEXT_EXTS = ["txt", "md", "csv", "log", "json"];
const WORD_EXTS = ["doc", "docx", "docm"];
const PPT_EXTS = ["ppt", "pptx", "pptm"];
const EXCEL_EXTS = ["xls", "xlsx", "xlsm"];

/** Office 系の「角丸正方形 + 頭文字」チップ */
const OfficeChip: React.FC<{ label: string; color: string; size: number }> = ({
  label,
  color,
  size,
}) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: `${Math.round(size * 0.22)}px`,
      bgcolor: color,
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      fontSize: size * 0.58,
      lineHeight: 1,
      flexShrink: 0,
      userSelect: "none",
    }}
  >
    {label}
  </Box>
);

/**
 * 拡張子に応じたファイル種別アイコン (F014: サムネイル非表示時のフォールバック)。
 * Word/PowerPoint/Excel は角丸正方形 + 頭文字、画像・動画・PDF・テキストは MUI アイコン、
 * それ以外は従来の InsertDriveFile を表示する。
 */
export const FileTypeIcon: React.FC<FileTypeIconProps> = ({
  fileName,
  size = 24,
}) => {
  const ext = (fileName.split(".").pop() || "").toLowerCase();

  if (WORD_EXTS.includes(ext))
    return <OfficeChip label="W" color="#2B579A" size={size} />;
  if (PPT_EXTS.includes(ext))
    return <OfficeChip label="P" color="#D24726" size={size} />;
  if (EXCEL_EXTS.includes(ext))
    return <OfficeChip label="E" color="#217346" size={size} />;

  if (IMAGE_EXTS.includes(ext))
    return <ImageOutlinedIcon sx={{ fontSize: size }} />;
  if (VIDEO_EXTS.includes(ext))
    return <SlideshowOutlinedIcon sx={{ fontSize: size }} />;
  if (ext === "pdf") return <PictureAsPdfOutlinedIcon sx={{ fontSize: size }} />;
  if (TEXT_EXTS.includes(ext))
    return <ArticleOutlinedIcon sx={{ fontSize: size }} />;

  return <InsertDriveFile sx={{ fontSize: size }} />;
};
